module.exports = __webpack_public_path__ + "static/media/Ramona Avenue, Albany, CA5.a76d3304.jpg";